/**
 * "DID YOU REQUEST ACCESS?" — the phone sheet. Chrome only; the question and
 * every string live in `components/PtAskBody.tsx` / `selectors.3e#ptAskVM`.
 *
 * Mounted by `MobileApp` while `s.ptAsk !== ''`, last of the playtest block so
 * it paints over the detail sheet that can raise it.
 */

import { PtAskBody, usePtAsk } from '../components/PtAskBody.tsx';
import { Sheet } from '../components/Sheet.tsx';
import { useQd } from '../store/index.ts';

export default function PtAskSheet(): JSX.Element | null {
  const s = useQd();
  const v = usePtAsk();
  if (!v) return null;

  return (
    <Sheet
      label="Playtest request confirm sheet"
      maxHeight="90vh"
      hs
      onClose={s.closePtAsk}
      header={{ title: v.title, titleClr: 'var(--acc)', titleFs: '8.5px', note: v.srcTxt }}
    >
      <PtAskBody v={v} m={{ hero: 132, pad: '13px 14px 18px', gap: 11 }} />
    </Sheet>
  );
}
